import { useSelector } from 'react-redux';
import './ApproveOrder.scss';
import { selectDetails } from '../../../../redux/features/VendorModule/VendorApproval/VendorApprovalSlice';

const mockOrder = { id: 0, orderType: "PO", status: "STV", orderNumber: "202508001", location: "MIA", site: "Warehouse 01", dateRequired: "2025-07-23", priority: "Medium", requestedBy: "Spirit Airlines", supplyChain: "9876542123", created: "2025-07-01", approvedDate: new Date().toISOString().split('T')[0], daysSince: "44", totalCost: "$1,500.00 USD", approvedBy: "Vendor(via Portal)" };
let mockDetails = [{
    id: 0,
    line: "1",
    partNumber: "111-222-333",
    description: "--",
    quantity: "5 EA",
    responseDate: "2025-06-15",
    leadDays: 10,
    currency: "USD",
    unitCost: "$100.00",
    discount: "-$50.00",
    duty: "$0.00",
    freightCost: "$0.00",
    taxIncluded: "+$50.00",
    subTotal: "$500.00",
    totalCost: "$500.00USD",
    estimatedShippingDate: "2025-07-15"
},
{
    id: 1,
    line: "2",
    partNumber: "111-222-333",
    description: "--",
    quantity: "5 EA",
    responseDate: "2025-06-15",
    leadDays: 10,
    currency: "USD",
    unitCost: "$100.00",
    discount: "-$50.00",
    duty: "$0.00",
    freightCost: "$0.00",
    taxIncluded: "+$50.00",
    subTotal: "$500.00",
    totalCost: "$500.00USD",
    estimatedShippingDate: "2025-07-15"
},
{
    id: 2,
    line: "3",
    partNumber: "111-222-333",
    description: "--",
    quantity: "5 EA",
    responseDate: "2025-06-15",
    leadDays: 10,
    currency: "USD",
    unitCost: "$100.00",
    discount: "-$50.00",
    duty: "$0.00",
    freightCost: "$0.00",
    taxIncluded: "+$50.00",
    subTotal: "$500.00",
    totalCost: "$500.00USD",
    estimatedShippingDate: "2025-07-15"
},
{
    id: 3,
    line: "4",
    partNumber: "111-222-333",
    description: "--",
    quantity: "5 EA",
    responseDate: "2025-06-15",
    leadDays: 10,
    currency: "USD",
    unitCost: "$100.00",
    discount: "-$50.00",
    duty: "$0.00",
    freightCost: "$0.00",
    taxIncluded: "+$50.00",
    subTotal: "$500.00",
    totalCost: "$500.00USD",
    estimatedShippingDate: "2025-07-15"
}];

const boldColumns = ["company", "approvedDate", "orderType", "approvedBy", "totalCost", "leadDays"];
const boldColumnsDet = ["leadDays"];
const hlghtColumns = ["orderNumber"];

const columns = {
    company: "Company",
    location: "Location",
    site: "Site",
    approvedDate: "Approved Date",
    orderType: "Order Type",
    orderNumber: "Order Number",
    requestedBy: "Requested By",
    approvedBy: "Approved By",
    totalCost: "Total Order"
}

const detailColumns = {
    line: "Line",
    partNumber: "PN",
    partName: "Description",
    quantity: "QTY",
    responseDate: "Response Date",
    leadDays: "Lead Days",
    currency: "Currency",
    unitPrice: "Unit Cost",
    discount: "Discount",
    duty: "Duty",
    freightCost: "Freight Cost",
    tax: "Tax",
    subtotal: "Subtotal",
    totalCost: "Total Cost",
    shippingDate: "Estimated Shipping"
}

const ApproveOrder = ({ okClick, order }) => {
    const allDetails = useSelector(selectDetails);
    const orderDetails = order ? (allDetails?.[order?.id] ?? []) : [];

    return (
        <div className='approve-order-component'>
            {/* {JSON.stringify(order)} */}
            <div className='header'>
                <div>

                    <i className='icon-success'></i>
                    <b>The following Order has been approved</b>
                </div>
                <button className='filled greenButton' onClick={okClick}>
                    OK
                </button>
            </div>
            <div className='app-order-content'>
                <div className='order'>
                    <div className='header-order'>
                        {Object.values(columns).map(v => <b key={v}>{v}</b>)}
                    </div>
                    <div className='order-content'>
                        {Object.keys(columns).map(key => <span className={`${boldColumns.includes(key) ? 'bold' : ''} ${hlghtColumns.includes(key) ? 'hlght' : ''}`} key={key}>{order?.[key] || "--"}</span>)}

                    </div>
                </div>
                <b>Order Details</b>
                <div className='order-details'>
                    <div className='header-detail center-selector'>
                        {Object.values(detailColumns).map(dC => <b key={dC}>{dC}</b>)}
                    </div>
                    {orderDetails?.map(detail =>
                        <div className='order-detail center-selector'>
                            {Object.keys(detailColumns).map(key => <span className={`${boldColumnsDet.includes(key) ? 'bold' : ''}`} key={key}>{detail[key] || "--"}</span>)}
                        </div>
                    )}

                </div>

            </div>
        </div>
    )
}
export default ApproveOrder;